import { render, staticRenderFns } from "./CmsRegistObstacle.vue?vue&type=template&id=3b5d46da&scoped=true&"
import script from "./CmsRegistObstacle.vue?vue&type=script&lang=js&"
export * from "./CmsRegistObstacle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5d46da",
  null
  
)

export default component.exports